'use client'

import { ReactNode } from 'react'
import dynamic from 'next/dynamic'

import { Link } from '@/i18n/navigation'

const PageBuilder = dynamic(
  () => import('@segway/core/src/components/pagebuilder/pagebuilder' as string),
  {
    ssr: false,
  },
)

const PageBuilderRender = PageBuilder as unknown as (props: {
  html: string
  className?: string
  linkComponent: unknown
}) => ReactNode

export default function PageBuilderRenderer({ content }: { content: string }) {
  return <PageBuilderRender html={content} linkComponent={Link} />
}
